import { useState } from "react";
import { Seo } from "@/components/site/Seo";
import { homeMeta } from "@/seo/routeMeta";
import { scrollToId } from "@/components/site/SectionLink";
import { SUPPORT_REQUEST } from "@/components/site/data";
import { Hero, ExploreSolutions } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Trust } from "@/components/site/Trust";
import { About } from "@/components/site/About";
import { Industries } from "@/components/site/Industries";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Support } from "@/components/site/Support";
import { Contact } from "@/components/site/Contact";

export default function HomePage() {
  const [preselect, setPreselect] = useState(null);

  const handleQuote = (service) => {
    setPreselect({ service, ts: Date.now() });
    scrollToId("contact");
  };

  return (
    <div data-testid="landing-page">
      <Seo {...homeMeta()} />
      <Hero />
      <ExploreSolutions />
      <Services onQuote={handleQuote} />
      <Trust />
      <About />
      <Industries />
      <ServiceArea />
      <Support onRequest={() => handleQuote(SUPPORT_REQUEST)} />
      <Contact preselect={preselect} />
    </div>
  );
}
